module.exports = __webpack_public_path__ + "img/step_3.1a954d7a.svg";